import { useState } from 'react';
import { useNotifications } from './useNotifications';

export const useCurrentGeolocation = () => {
  const { showErrorNotification } = useNotifications();
  const [currentGeolocation, setGeolocaton] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const success = (pos) => {
    setLoading(false);
    setGeolocaton({
      markerCoords: {
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
      },
      time: new Date().toISOString(),
    });
  };

  function error(err) {
    setLoading(false);
    setGeolocaton(null)
    console.error(err);
    showErrorNotification({
      title: 'error',
      description: 'errorRetrievingGeolocation',
    });
  }

  const getGeolocation = () => {
    setLoading(true);
    navigator.geolocation.getCurrentPosition(success, error, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    });
  };

  return { currentGeolocation, isLoading, getGeolocation };
};
